import { MonitorType } from '$shared/constants/MonitorType';
import type { IMonitor } from '$shared/interfaces/api/IMonitor';
import { DatasetMonitor } from '$shared/models/monitor/DatasetMonitor';
import { LicenseMonitor } from '$shared/models/monitor/LicenseMonitor';
import type { Monitor } from '$shared/models/monitor/Monitor';

export class MonitorFactory {
  static get(monitor: IMonitor): Monitor {
    if (monitor.type === MonitorType.License) {
      return new LicenseMonitor(monitor);
    }

    if (monitor.type === MonitorType.Dataset) {
      return new DatasetMonitor(monitor);
    }

    throw new Error(`Monitor type ${monitor.type} is not supported.`);
  }
}
